import "./App.css";
import Router from "./Routes/Router";

function App() {
	return (
		<div className="App">
			<Router />
		</div>
	);
}

export default App;
